import { type ReactNode } from "react";
import { cn } from "../../utils";

type Props = {
  children: ReactNode;
  className?: string;
};

export const DrawerFooter = ({ children, className }: Props) => {
  return (
    <footer
      data-drawer-footer
      className={cn(
        "w-full p-4 border-t border-neutral-500/10 flex items-center justify-end gap-2",
        className,
      )}
    >
      {children}
    </footer>
  );
};
